import { render, staticRenderFns } from "./MusicTab.vue?vue&type=template&id=81d610f6&"
import script from "./MusicTab.vue?vue&type=script&lang=js&"
export * from "./MusicTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports